import _objectWithoutProperties from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import { usePress } from '@react-native-aria/interactions';
import { mergeProps } from '@react-aria/utils';
export function useButton(props) {
  var isDisabled = props.isDisabled,
      onPress = props.onPress,
      onPressStart = props.onPressStart,
      onPressEnd = props.onPressEnd,
      onPressChange = props.onPressChange,
      rest = _objectWithoutProperties(props, ["isDisabled", "onPress", "onPressStart", "onPressEnd", "onPressChange"]);

  var _usePress = usePress({
    onPressStart: onPressStart,
    onPressEnd: onPressEnd,
    onPressChange: onPressChange,
    onPress: onPress,
    isDisabled: isDisabled
  }),
      pressProps = _usePress.pressProps,
      isPressed = _usePress.isPressed;

  var mergedProps = mergeProps(pressProps, rest, {
    accessibilityState: {
      disabled: isDisabled
    },
    accessibilityRole: 'button',
    disabled: isDisabled
  });
  return {
    isPressed: isPressed,
    buttonProps: mergedProps
  };
}